<app-footer class="p-2">
  <a class="mx-auto" href="https://www.chiefnet.io" target="_blank">ChiefNET Private Limited.</a>
</app-footer>
